import { DeleteEcshopAccountsApi } from "@/features/accounts/ecshop/services/delete-accounts-api";
import { DeleteEcshopAccountsRequestModel } from "@/features/accounts/ecshop/services/delete-accounts-model";

/// その他連携サービス口座削除画面処理
export class DeleteEcshopAccountsService {
  private deleteEcshopAccountsApi = new DeleteEcshopAccountsApi();

  /**
   * その他連携サービス口座削除API実行
   */
  public async deleteEcshopAccounts(param: DeleteEcshopAccountsRequestModel) {
    return await this.deleteEcshopAccountsApi.deleteEcshopAccounts(param);
  }
}
